import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { PmStore } from "@/state";





const queryApplicationNotifications = gql`
  query applicationNotifications($organizationId: UUID!, $applicationId: UUID!, $page: Int) {
    applicationNotifications(organizationId: $organizationId, applicationId: $applicationId, page: $page) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      nodes {
        category_id
        created_ts
        message
        notification_id
        plain_message
        subject
        recpients
      }
      
      
    }
  }
`;






export function useNotificationActions() {
    const state = PmStore();
    // const [apiSetReservationPublished] = useMutation(mutationSetReservationPublished);

    const [apiApplicationNotifications] = useLazyQuery(queryApplicationNotifications);





    async function GetApplicationNotifications(applicationId: string, page: number) {
        let organizationId = state?.selectedOrganization?.id;
        try {
            let result = await apiApplicationNotifications({ variables: { organizationId, applicationId, page } }) as any;
            return result.data as {};
        }
        catch (err) {
            toast.error("Api Error, Unable to set reservation published flag");
        }
    }





    return {
        GetApplicationNotifications
    };
}




